import { z } from 'zod';
import { CardEnum } from './CardState.ts';
import { EnumUtils } from '@colonist/utils';
import { createKeyRecordSchema } from './KeyRecordSchemas.ts';
const cardEnumKeys = EnumUtils.getEnumValues(CardEnum);
export const tradeRatiosStateSchema = createKeyRecordSchema(cardEnumKeys, z.number().int().positive());
